import React from "react";

export default function DatabaseForegroundPanel({ hasSelection, children }) {
  return (
    <div className={`dbMainPanel${hasSelection ? " open" : ""}`}>
      {children}
    </div>
  );
}
